const unitValueMap = {
  None: {
    value: 1,
    unit: '',
  },
  Thousand: {
    value: 1000,
    unit: 'K',
  },
  Million: {
    value: 1000000,
    unit: 'M',
  },
  Billion: {
    value: 1000000000,
    unit: 'B',
  },
};

export { unitValueMap };
